import { render } from "./RiskLevelsGrid.vue?vue&type=template&id=5dbfd246&scoped=true"
import script from "./RiskLevelsGrid.vue?vue&type=script&lang=js"
export * from "./RiskLevelsGrid.vue?vue&type=script&lang=js"

import "./RiskLevelsGrid.vue?vue&type=style&index=0&id=5dbfd246&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbfd246"]])

export default __exports__